import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import JSON from 'json3';
import {invokeLast, invokeLastFunc} from 'util/FuncUtil';
///////////////////////////
/////// View Store  ///////
///////////////////////////


var ViewStoreModel = Backbone.Model.extend({
	urlRoot: '../json/viewStore',
});
var ViewStoreCollection = Backbone.Collection.extend({
	model: ViewStoreModel,
	url: '../json/viewStore/all',
	findUrl: '../json/viewStore/find',
});
/**
 * not used atm - client only needs ViewStoreEntry
 */
var storeCollection = new ViewStoreCollection();

////////////////////////////////
/////// View Store Entry ///////
////////////////////////////////

var ViewStoreEntryModel = Backbone.Model.extend({
	urlRoot: '../json/viewStore/entry',
	initialize: function () {
		this.delayed = invokeLastFunc(this, ['saveQueue']);
		this.savePersistedAttributes();
		this.listenTo(this, "sync", this.savePersistedAttributes);
	},
	savePersistedAttributes: function () {
		this.persistedAttributes = this.toJSON();
	},
	isPersisted: function () {
		return _.isEqual(this.persistedAttributes, this.toJSON());
	},
});

var ViewStoreEntryCollection = Backbone.Collection.extend({
	model: ViewStoreEntryModel,
	url: '../json/viewStore/entry/find',
	getOrAdd: function (vsId) {
		if (!vsId.view || !vsId.key) {
			console.error('invalid model for viewstoreentry: ', JSON.stringify(vsId));
			return new ViewStoreEntryModel(); //prevent failing until persist
		} //invalid
		var storeEntry = this.findWhere(vsId);
		if (!storeEntry) storeEntry = this.add(vsId);
		return storeEntry;
	},
});

var entryCollection = new ViewStoreEntryCollection();


///////////////////////////
/////// Initializer ///////
///////////////////////////

//fetchContext
var fc = {queue: undefined, defer: undefined};

function fetchQueue() {
	var queue = fc.queue;
	var defer = fc.defer;
	fc.queue = undefined;
	fc.defer = undefined;
	var ajaxData = {
		type: "POST",
		contentType: "application/json",
		data: JSON.stringify(queue),
		add: true,
		merge: true,
		remove: false,
	};
	$.when(
		//storeCollection.fetch(ajaxData),
		entryCollection.fetch(ajaxData),
	).done(defer.resolve).fail(defer.reject);
}

function enqueueFetch(viewName) {
	fc.queue = fc.queue || [];
	fc.defer = fc.defer || $.Deferred();
	if (_.isArray(viewName)) fc.queue.push.apply(fc.queue, viewName);
	else fc.queue.push(viewName);
	invokeLast(fc, fetchQueue, 1);
	return fc.defer;
}

export const ViewStoreModule = {
	stores: storeCollection,
	entries: entryCollection,
	/**
	 * call on Module init
	 */
	enqueueFetch: enqueueFetch,
};

export default ViewStoreModule;